module.exports = __webpack_public_path__ + "static/img/bg2.2fabcfa1.jpg";